<template>
  <div>
    <v-dialog v-model="show" max-width="600" :persistent="true">
      <v-card>
        <v-card-title class="headline">{{ $t('components.dialog.acceptLicense.title') }}</v-card-title>

        <v-card-text>
          <div v-if="!vendor">
            <p>
              <em>{{ $t('components.dialog.acceptLicense.contentText1') }} </em>
            </p>
            <p>
              {{ $t('components.dialog.acceptLicense.contentText2') }}
            </p>
          </div>

          <div v-if="vendor">
            <p>
              <em>{{ $t('components.dialog.acceptLicense.contentText3') }} </em>
            </p>
            <p>
              {{ $t('components.dialog.acceptLicense.contentText4') }}
            </p>
          </div>

          <v-checkbox v-model="accept" :label="$t('components.dialog.acceptLicense.confirmLicense')"></v-checkbox>
        </v-card-text>

        <v-card-actions class="pr-4 pb-3">
          <v-spacer></v-spacer>

          <v-btn color="primary" class="black--text" :disabled="!accept" @click="acceptLicense()">
            {{ $t('common.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { UserService } from '../../services/user.service';

export default {
  data() {
    return {
      accept: false,
    };
  },

  props: {
    visible: Boolean,
    vendor: {
      type: Boolean,
      default: false,
    },
    afterAcceptPromiseResolve: {
      type: Function,
      require: true,
    },
  },

  model: {
    prop: 'visible',
    event: 'update',
  },

  computed: {
    show: {
      get: function () {
        return this.visible;
      },
      set: function (value) {
        this.$emit('update', value);

        if (value === false) {
          this.$emit('close');
        }
      },
    },
  },

  methods: {
    acceptLicense() {
      new UserService().setAcceptLicense().then(() => {
        this.accept = false;
        this.show = false;
        this.afterAcceptPromiseResolve(true);
      });
    },
  },
};
</script>
